/* Maison d'Esteban — mega-meniul desktop (P13.1) + meniul vizual pe telefon (P13.2). 10 oct 2026.
   Încărcat doar când panourile noi sunt randate (setările antetului ≠ „clasic”).
   1. Hover-intent: deschiderea unui panou cu mouse-ul așteaptă data-est-intent ms (implicit 120) când niciun panou nu e deschis;
      între elemente, cu un panou deja deschis, comutarea rămâne instantanee (header-menu.js). Tastatura/atingerea: fără întârziere.
   2. Pozele panourilor au data-src (header-menu.js scoate loading=lazy după load) → le punem la prima intenție (hover/focus/deschidere).
   3. Click-uri: linkurile cu data-est-list="mega_menu" publică est_select_item (produse, + originea pentru est_view_item / atribuire)
      sau est_menu_click (colecții) prin Shopify.analytics.publish — același format ca assets/est-track.js.
   4. M4: filtrul de mărci. M5: câmpul de căutare închide sertarul și deschide căutarea predictivă. */
(() => {
  if (window.__estMega) return;
  window.__estMega = true;

  const ctx = window.EST_CTX || {};
  const debug = /[?&]est_debug=1/.test(location.search) || (() => { try { return localStorage.getItem('est_debug') === '1'; } catch (e) { return false; } })();
  const publish = (name, data) => {
    const payload = { ...data, page_type: ctx.tpl || '', site: ctx.shop || location.hostname };
    if (debug) console.log('[est-mega]', name, payload);
    try { window.Shopify?.analytics?.publish?.(name, payload); } catch (e) { /* fără pixel = fără efect */ }
  };

  /* ---- 0. panourile desktop vin din <template data-est-mega-tpl> (snippets/mega-menu-list.liquid) — puse în pagină o singură dată,
     la prima intenție pe meniu (hover / focus / deschidere), înainte ca Tinker să deschidă submeniul ---- */
  const materialize = () => {
    const tpls = document.querySelectorAll('template[data-est-mega-tpl]');
    if (!tpls.length) return;
    tpls.forEach((t) => t.replaceWith(t.content));
    document.dispatchEvent(new CustomEvent('est:mega-ready'));
  };
  const onIntent = (e) => {
    const t = e.target instanceof Element ? e.target : null;
    if (t && t.closest('header-menu, .menu-list')) {
      materialize();
      window.removeEventListener('pointerover', onIntent, true);
      window.removeEventListener('focusin', onIntent, true);
    }
  };
  window.addEventListener('pointerover', onIntent, true);
  window.addEventListener('focusin', onIntent, true);

  /* ---- 2. poze la prima intenție ---- */
  const hydrate = (root) => {
    if (!root || root.dataset.estHydrated) return;
    root.dataset.estHydrated = '1';
    root.querySelectorAll('img[data-est-defer]').forEach((img) => {
      if (img.dataset.srcset) img.srcset = img.dataset.srcset;
      if (img.dataset.src) img.src = img.dataset.src;
    });
  };
  const panelOf = (li) => li?.querySelector?.('[data-est-mega]');

  /* ---- 1. hover-intent ---- */
  const firstPanel = document.querySelector('[data-est-mega]') || document.querySelector('template[data-est-mega-tpl]')?.content.querySelector('[data-est-mega]');
  const delay = Number(firstPanel?.closest('[data-est-intent]')?.dataset.estIntent ?? document.querySelector('[data-est-intent]')?.dataset.estIntent ?? 120);
  let pending = null;
  let timer = 0;
  window.addEventListener('pointerenter', (e) => {
    const li = e.target;
    if (!(li instanceof Element) || !li.matches('header-menu .menu-list__list-item')) return;
    const panel = panelOf(li);
    if (panel && window.matchMedia('(min-width: 750px)').matches) hydrate(panel);
    if (!delay || e.pointerType !== 'mouse' || !li.querySelector('[ref="submenu[]"]')) return; // sintetic / tastatură / atingere → direct
    const hm = li.closest('header-menu');
    if (hm?.getAttribute('aria-expanded') === 'true') return; // un panou e deja deschis → comutare instantanee
    e.stopImmediatePropagation(); // oprește activarea Tinker (delegată pe document, în captură)
    clearTimeout(timer);
    pending = li;
    timer = setTimeout(() => {
      if (pending === li && li.matches(':hover')) li.dispatchEvent(new PointerEvent('pointerenter', { bubbles: false }));
      pending = null;
    }, delay);
  }, true);
  window.addEventListener('pointerleave', (e) => {
    if (e.target === pending) { clearTimeout(timer); pending = null; }
  }, true);
  // tastatură: focus pe link sau butonul de deschidere → pozele panoului
  document.addEventListener('focusin', (e) => {
    const li = e.target instanceof Element ? e.target.closest('header-menu .menu-list__list-item') : null;
    if (li) hydrate(panelOf(li));
  });

  // deschidere din butonul de submeniu (click / Enter) sau din orice altă cale: submeniul pierde `inert` → pozele
  if ('MutationObserver' in window) {
    document.querySelectorAll('header-menu [ref="submenu[]"]').forEach((sub) => {
      new MutationObserver(() => {
        if (sub.inert || !window.matchMedia('(min-width: 750px)').matches) return;
        materialize();
        hydrate(sub.querySelector('[data-est-mega]'));
      }).observe(sub, { attributes: true, attributeFilter: ['inert', 'data-active'] });
    });
  }

  /* ---- 3. măsurarea click-urilor ---- */
  document.addEventListener('click', (e) => {
    const a = e.target instanceof Element ? e.target.closest('a[data-est-list]') : null;
    if (!a) return;
    const box = a.closest('[data-est-list-name]');
    const list_id = a.dataset.estList || 'mega_menu';
    const list_name = box?.dataset.estListName || 'Mega-meniu';
    if (a.dataset.estPid) {
      if (window.AronaCX) return; /* MES 3.0: arona-cx.js publică est_select_item (+ GA4) și ține originea → fără dublură */
      const info = {
        list_id, list_name, index: Number(a.dataset.estIndex || 0),
        item_id: a.dataset.estPid, item_name: a.dataset.estName || '', price: Number(a.dataset.estPrice || 0),
      };
      publish('est_select_item', info);
      try { sessionStorage.setItem('est_origin', JSON.stringify({ pid: info.item_id, list_id, list_name, index: info.index, t: Date.now() })); } catch (err) { /* privat */ }
    } else {
      let path = a.getAttribute('href') || '';
      try { path = new URL(a.href, location.href).pathname; } catch (err) { /* rămâne href */ }
      publish('est_menu_click', { list_id, list_name, link_text: (a.textContent || '').replace(/\s+/g, ' ').trim().slice(0, 80), link_url: path });
    }
  }, true);

  /* ---- 4a. M4: filtrul de mărci ---- */
  const norm = (s) => (s || '').normalize('NFD').replace(/[̀-ͯ]/g, '').toLowerCase().trim();
  document.addEventListener('input', (e) => {
    const inp = e.target instanceof Element ? e.target.closest('[data-est-brand-filter]') : null;
    if (!inp) return;
    const root = inp.closest('[data-est-mega]');
    const q = norm(inp.value);
    let shown = 0;
    root.querySelectorAll('[data-est-brand]').forEach((li) => {
      const ok = !q || norm(li.dataset.estBrand).includes(q);
      li.hidden = !ok;
      if (ok) shown += 1;
    });
    const none = root.querySelector('[data-est-brand-none]');
    if (none) none.hidden = shown > 0;
  });
  document.addEventListener('keydown', (e) => {
    const inp = e.target instanceof Element ? e.target.closest('[data-est-brand-filter]') : null;
    if (!inp || e.key !== 'Enter') return;
    e.preventDefault();
    const root = inp.closest('[data-est-mega]');
    const vis = [...root.querySelectorAll('[data-est-brand]:not([hidden]) a')];
    if (inp.value.trim() && vis.length >= 1) { vis[0].click(); return; }
    if (inp.value.trim()) location.href = `${inp.dataset.searchUrl || '/search'}?q=${encodeURIComponent(inp.value.trim())}&type=product&options%5Bprefix%5D=last`;
  });

  /* ---- 4b. M5: căutarea din sertar + pozele la deschiderea sertarului ---- */
  document.addEventListener('click', (e) => {
    const btn = e.target instanceof Element ? e.target.closest('[data-est-nav-search]') : null;
    if (!btn) return;
    // sertarul se închide; search-inline.liquid deschide panoul la același click ([data-mobile-search-trigger], pe document)
    const drawer = btn.closest('header-drawer');
    try { drawer?.close?.(); } catch (err) { /* sertarul rămâne */ }
    // la finalul animației, header-drawer.js întoarce focusul pe hamburger → îl readucem în câmpul de căutare
    const inp = document.querySelector('.search-inline__input');
    [350, 700].forEach((ms) => setTimeout(() => { if (inp && document.activeElement !== inp) inp.focus({ preventScroll: true }); }, ms));
  });
  const nav = document.querySelector('[data-est-nav]');
  const details = nav?.closest('details');
  if (details) {
    // header-drawer.js închide toate <details> din sertar la închidere → redeschidem familiile (data-est-open) la fiecare deschidere
    const onToggle = () => { if (details.open) { hydrate(nav); nav.querySelectorAll('details[data-est-open]').forEach((d) => { d.open = true; }); } };
    details.addEventListener('toggle', onToggle);
    if (details.open) hydrate(nav);
  }
})();
